var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcEnter = function SvgIcEnter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_enter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.548 14.933-2.146 2.135a.926.926 0 0 0 0 1.319.926.926 0 0 0 1.318 0l3.733-3.734c.082-.093.152-.198.199-.303a.94.94 0 0 0-.199-1.015L13.72 9.602a.95.95 0 0 0-1.33 0c-.373.361-.362.956 0 1.33l2.147 2.135H5.588a.936.936 0 0 0-.933.933c0 .513.42.933.933.933H14.548ZM14 4.667a9.348 9.348 0 0 0-8.4 5.18.935.935 0 0 0 .42 1.26.935.935 0 0 0 1.26-.42c1.832-3.699 6.312-5.204 10.01-3.384 3.698 1.832 5.203 6.312 3.383 10.01a7.483 7.483 0 0 1-6.661 4.154 7.408 7.408 0 0 1-6.685-4.154.935.935 0 0 0-1.26-.42.935.935 0 0 0-.42 1.26 9.332 9.332 0 0 0 12.518 4.2 9.332 9.332 0 0 0 4.2-12.518 9.333 9.333 0 0 0-8.353-5.18L14 4.667Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_enter_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgIcEnter;